import { createSlice } from '@reduxjs/toolkit';
import { createCreateDeviceReducer, createUpdateDeviceReducer, createDeleteDeviceReducer, DevicesState } from './reducers';

export type { DevicesState };

const initialState: DevicesState = {
  isMutating: false,
};

export const devicesSlice = createSlice({
  name: 'devices',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    createCreateDeviceReducer(builder);
    createUpdateDeviceReducer(builder);
    createDeleteDeviceReducer(builder);
  },
});

export default devicesSlice.reducer;
